exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MenuBar_MenuBar_k1avi ul {\n    padding-left: 15%;\n    display: flex;\n    flex-flow: row;\n    background-color: gainsboro;\n    color: #cccccc;\n}", ""]);

// Exports
exports.locals = {
	"MenuBar": "MenuBar_MenuBar_k1avi"
};